import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { concatMap } from 'rxjs/operators';

import { PAGE_SIZE_OPTIONS } from '@app/core/_config/pagination.config';
import { LocationDetailsService } from '@app/core/locations/services/location-details.service';
import { LocationService } from '@app/core/locations/services/location.service';
import { SettingsService } from '@app/core/settings/services/settings.service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

import { LocationApiService } from '../../../../v2/modules/shared/services/api/location/location-api.service';

type NavLink = {
  name :string;
  link :string;
};

@Component({
  selector: 'location',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
})
export class LocationComponent implements OnInit {
  constructor(
    private locationSvc :LocationService,
    private activeRoute :ActivatedRoute,
    private cd :ChangeDetectorRef,
    private locationDetailsSvc :LocationDetailsService,
    private router :Router,
    private ft :FeatureToggleService,
    private settingsService :SettingsService,
    private locationApiService :LocationApiService,
  ) {
    this.settingsService
      .getKeyValue('track_inventory_by_location')
      .subscribe((settingEnabled :boolean) => {
        this.ftLocationBins = settingEnabled;
        this.cd.detectChanges();
      });
  }

  public location :any = {};
  public loading :boolean = true;
  public navLinks :NavLink[] = [
    { name: 'Details', link: 'details' },
    { name: 'Logs', link: 'logs' },
  ];
  public ftLocationBins :boolean = false;
  relations = ['picklist:id,status,wip_bin_location_id'];
  PAGE_SIZE_OPTIONS = PAGE_SIZE_OPTIONS;

  ngOnInit() :void {
    this.activeRoute.params
      .pipe(
        concatMap((params) =>
          this.locationApiService.getByIdV2({
            id: params.id,
            params: {
              relations: this.relations.join('|'),
            },
          }),
        ),
      )
      .subscribe((location) => {
        this.locationDetailsSvc.set(location);
        this.location = location;
        this.loading = false;
        this.cd.detectChanges();
      });
  }

  locationAdjustmentEntry() {
    this.router.navigate([`/inventory/adjustment-entries/create`], {
      queryParams: { location: this.location.id },
    });
  }
}
